import Cookies from 'js-cookie';
import { LOGGED_IN_USER_COOKIE } from '../constants';
import { validateLoggedInUserCookie } from './validateLoggedInUserCookie';
export const AuthCookies = {
  /**
   * Gets authorized user cookie value. Usually they take this signature: <tenant>\<consultantNumber>
   */
  getAuthorizedUserValue() {
    const loggedInUserCookie = Cookies.get(LOGGED_IN_USER_COOKIE);
    return validateLoggedInUserCookie(loggedInUserCookie);
  },
  hasAuthorizedUserValue() {
    return !!this.getAuthorizedUserValue();
  }
};
//# sourceMappingURL=AuthCookies.js.map